import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { withInstallation } from "../../components/InstallationContext";
import { Loading } from "../../components/LoadingFork";
import { getEnabledConciergePages, isConciergeModuleEnabled, isConciergePageEnabled } from "../../lib/conciergeFeature";
import ConciergeDashboard from "./dashboard";
import OffsiteTickets from "./offsite";
import VipRouting from "./vip-routing";
import ContactTemplatePage from "./vip-routing/ContactTemplatePage";
import VipAlerts from "./vip-alerts";
import VipBooking from "./vip-booking/VipBooking";
import RunnerShifts from "./shifts";
import Porters from "./porters";
import ParkingAudit from "./parking-audit";

const CONCIERGE_PAGES = {
  dashboard: ConciergeDashboard,
  offsite: OffsiteTickets,
  vipRouting: VipRouting,
  vipAlerts: VipAlerts,
  vipBooking: VipBooking,
  shifts: RunnerShifts,
  porters: Porters,
  parkingAudit: ParkingAudit,
};

const CONCIERGE_PATHS = {
  dashboard: "dashboard",
  offsite: "offsite",
  vipRouting: "vip-routing",
  vipAlerts: "vip-alerts",
  vipBooking: "vip-booking",
  shifts: "shifts",
  porters: "porters",
  parkingAudit: "parking-audit",
};

const CONCIERGE_PAGE_BY_PATH = Object.keys(CONCIERGE_PATHS).reduce((acc, page) => {
  acc[CONCIERGE_PATHS[page]] = page;
  return acc;
}, {});

function pagePath(page) {
  return CONCIERGE_PATHS[page] || page;
}

function ConciergePage({ match, facility, installation }) {
  if (!facility) return <Loading />;

  const enabledPages = getEnabledConciergePages(facility);
  const vipBookingEnabled = isConciergePageEnabled(facility, "vipBooking");

  if (!isConciergeModuleEnabled(facility) || (enabledPages.length === 0 && !vipBookingEnabled)) {
    return <Redirect to={`${match.url.replace(/\/concierge$/, "")}/profile`} />;
  }

  return (
    <Switch>
      <Route path={`${match.path}/vip-routing/:contactId`} component={ContactTemplatePage} />
      <Route
        path={`${match.path}/vip-booking/:bookingId`}
        render={(routeProps) => {
          if (!enabledPages.includes("vipAlerts") && !vipBookingEnabled) {
            return <Redirect to={`${match.url}/${pagePath(enabledPages[0])}`} />;
          }

          return <VipBooking {...routeProps} installation={installation} />;
        }}
      />
      <Route
        path={`${match.path}/:page`}
        render={(routeProps) => {
          const { match: routeMatch } = routeProps;
          const requestedPage = CONCIERGE_PAGE_BY_PATH[routeMatch.params.page] || routeMatch.params.page;
          const page = enabledPages.includes(requestedPage) ? requestedPage : enabledPages[0];

          if (page !== requestedPage) {
            return <Redirect to={`${match.url}/${pagePath(page)}`} />;
          }

          const Component = CONCIERGE_PAGES[page];

          return <Component {...routeProps} />;
        }}
      />
      <Redirect to={enabledPages.length ? `${match.url}/${pagePath(enabledPages[0])}` : `${match.url.replace(/\/concierge$/, "")}/profile`} />
    </Switch>
  );
}

export default withInstallation(ConciergePage);
